import { NavLink } from 'react-router-dom';
import { ClipboardCopyIcon, DocumentTextIcon, FireIcon } from '@heroicons/react/outline';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const SuccessStats = ({allUserMsg, copiedMsg, likedMsg}) => {

    const navlinkStyle = {textDecoration: 'none'}

    var all = allUserMsg ? allUserMsg?.length : 0;
    var copied = (allUserMsg && copiedMsg) ? ((copiedMsg?.length / allUserMsg?.length) * 100) : 0
    var liked = (allUserMsg && likedMsg) ? ((likedMsg?.length / allUserMsg?.length) * 100) : 0

    const stats = [
        { name: 'Total People Prospected', stat:  all, icon: DocumentTextIcon, href: '/allProjects', },
        { name: 'Prosect Message Copied', stat:  (copied === 0) ? copied + ' %' : copied.toFixed(2) + ' %', icon: ClipboardCopyIcon, href: '/copiedProjects', length: copiedMsg?.length},
        {   name: 'Prospect Message Fire', 
            stat: (liked > 100) ? (<span> &gt; 100.00%</span>) : ((liked === 0) ? liked + ' %' : liked.toFixed(2) + ' %'),  
            icon: FireIcon, href: '/likedProjects', length: likedMsg?.length
        },
    ]

    return (
        <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900 my-4">Total Prospected</h3>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {stats.map((item) => (
                <div
                key={item.name}
                className="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden"
                >
                <dt>
                    <div className="absolute bg-green-500 rounded-md p-3">
                    <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 text-sm font-medium text-gray-500 truncate">{item.name}</p>
                </dt>
                <dd className="ml-16 pb-6 items-baseline sm:pb-7">
                    <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                    {item.length > 0 ?
                    <div className="font-medium text-gray-600 text-right my-2">
                        Amount: {item.length}
                    </div>
                    :
                    null }
                    <div className="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
                    <div className="text-sm">
                        <NavLink
                        style={navlinkStyle}
                        key={item.name}
                        exact
                        to={item.href}
                        className={classNames(
                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                        'group flex items-center px-2 py-2 text-base font-medium rounded-md'
                        )}
                        >
                            <item.icon className="mr-3 h-6 w-6 text-green-300" aria-hidden="true" />
                            View all
                        </NavLink>
                    </div>
                    </div>
                </dd>
                </div>
            ))}
            </dl>
        </div>
    )
}

export default SuccessStats